const mode = import.meta.env.MODE;

export const appConfig = {
  api: {
    server: {
      development: 'http://localhost',
    }[mode],
  },
};
